import { HttpService } from '../../services/services.index';
import { EEndpoint } from '../../config/endpoint.config';
import { IChatMessage } from '../../domain/chat.interfaces';

export const ALL_MESSAGES_LOADED = 'ALL_MESSAGES_LOADED';
export const LAST_MESSAGES_LOADED = 'LAST_MESSAGE_LOADED';
export const RESET_MESSAGES = 'RESET_MESSAGES';

const httpService = new HttpService();
let lastMessageId = '';

export const loadAllMessages = (
  groupId: string,
  take: number,
  page: number,
) => {
  return (dispatch: any) =>
    httpService
      .get(EEndpoint.GROUP_CHAT, {
        params: { groupId: groupId, take: take, skip: page * take },
        silently: true,
      })
      .then((res: any) => {
        if (!res.messages.length) {
          return;
        }
        lastMessageId =
          page === 0
            ? !!res.messages.length
              ? res.messages[0].id
              : ''
            : lastMessageId;
        dispatch({
          type: ALL_MESSAGES_LOADED,
          payload: res,
        });
      });
};

export const loadLastMessages = (groupId: string) => {
  if (!lastMessageId) {
    return (dispatch: any) => dispatch(loadAllMessages(groupId, 20, 0));
  }
  return (dispatch: any) => {
    httpService
      .get(EEndpoint.GROUP_CHAT_LAST, {
        params: { groupId: groupId, lastMessageId: lastMessageId },
        silently: true,
      })
      .then((res: any) => {
        if (!res.length) {
          return;
        }
        lastMessageId = !!res.length ? res[0].id : lastMessageId;
        dispatch({
          type: LAST_MESSAGES_LOADED,
          payload: res,
        });
      });
  };
};

export const resetMessages = () => {
  return (dispatch: any) =>
    dispatch({
      type: RESET_MESSAGES,
    });
};

export const newMessage = (groupId: string, body: Partial<IChatMessage>) => {
  return (dispatch: any) => {
    httpService
      .post(EEndpoint.GROUP_CHAT, body, {
        params: { groupId: groupId },
        silently: true,
      })
      .then((res: any) => {
        dispatch(loadLastMessages(groupId));
      });
  };
};
